import React, {Component} from 'react';
import SideMenu from './SideMenu'
import MainContent from './MainContent'


class MainArea extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<div className="pusher">
      <div className="ui fluid container">
        <div className="ui two column grid">
          <SideMenu
            sideMenuVisible={this.props.sideMenuVisible}
          />
          <MainContent/>
        </div>
      </div>
    </div>)
  }
}

export default MainArea;




/** WEBPACK FOOTER **
 ** ./src/components/main/MainArea.js
 **/